import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {
  MoreVert as MoreVertIcon,
  ExitToApp as ExitToAppIcon,
} from "@material-ui/icons";
import { auth, signOut } from "../../../firebase/firebase.utils"; // Import auth and signOut

const options = [
  {
    name: "Déconnexion",
    icon: <ExitToAppIcon />,
    action: "logout", // Add an action identifier
  },
  // Add other menu options here if needed
];

const ITEM_HEIGHT = 48;

export default function LoggedMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      handleClose(); // Close menu after logout
      // Optionally: Redirect user or update UI state
    } catch (error) {
      console.error("Error signing out: ", error);
      // Handle logout error if needed
    }
  };

  const handleMenuClick = (action) => {
    if (action === "logout") {
      handleLogout();
    } else {
      handleClose();
      // Handle other actions if any
    }
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon style={{ color: "black" }} />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: 200,
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.name} // Use option.name as key
            onClick={() => handleMenuClick(option.action)} // Call specific handler based on action
          >
            {option.icon} {option.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
